import { createAction } from '@src/redux/helpers/createAction';

import { SET_IS_EDITING } from './constants';

export const setIsEditing = (payload) => {
  return createAction({
    type: SET_IS_EDITING,
    payload,
  });
};
